import { render, staticRenderFns } from "./BulkForm.vue?vue&type=template&id=1765da28&"
import script from "./BulkForm.vue?vue&type=script&lang=js&"
export * from "./BulkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports